var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCafe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "caf\\xE9_th\\xE9",
    "data-name": "caf\\xE9 th\\xE9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.51,29.62H45.92V28.17a.68.68,0,0,0-.68-.68H30.52a.69.69,0,0,0,0,1.37h14v5.22a13,13,0,0,1-6.41,11.18H25.07a13,13,0,0,1-6.4-11.18V28.86h4.56a.69.69,0,0,0,0-1.37H18a.69.69,0,0,0-.68.68v5.91a14.26,14.26,0,0,0,2,7.3,14.44,14.44,0,0,0,3.38,3.88H18a.68.68,0,0,0-.68.68,4.5,4.5,0,0,0,4.5,4.49H43.06a4.5,4.5,0,0,0,4.5-4.49.68.68,0,0,0-.68-.68H40.55a14.36,14.36,0,0,0,3.15-3.53h1.93a6.56,6.56,0,0,0,6.56-6.56V30.3A.67.67,0,0,0,51.51,29.62Zm-5.39,17a3.13,3.13,0,0,1-3.06,2.45H21.8a3.14,3.14,0,0,1-3.06-2.45H46.12Zm-.2-12.54v-.37H48.1v1.46a2.48,2.48,0,0,1-2.47,2.48h-.16A14.26,14.26,0,0,0,45.92,34.08Zm4.91,1.09a5.2,5.2,0,0,1-5.2,5.2H44.47A13.54,13.54,0,0,0,45.05,39h.58a3.85,3.85,0,0,0,3.84-3.84V33a.69.69,0,0,0-.68-.68H45.92V31h4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.26,19.32l-.35-.45a1.77,1.77,0,0,1,0-2.22.68.68,0,0,0-1.07-.85,3.14,3.14,0,0,0,0,3.92l.36.45a2.32,2.32,0,0,1,0,2.9l-.36.46a.66.66,0,0,0,.11.95.66.66,0,0,0,.42.15.67.67,0,0,0,.53-.26l.37-.46A3.67,3.67,0,0,0,32.26,19.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,20.85l-.35-.45a1.77,1.77,0,0,1,0-2.22.68.68,0,1,0-1.06-.85,3.13,3.13,0,0,0,0,3.92l.35.45a2.32,2.32,0,0,1,0,2.9l-.37.46a.69.69,0,0,0,.11,1,.76.76,0,0,0,.43.14.67.67,0,0,0,.53-.26l.36-.45A3.67,3.67,0,0,0,36,20.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.49,20.85l-.36-.45a1.77,1.77,0,0,1,0-2.22.68.68,0,1,0-1.07-.85,3.14,3.14,0,0,0,0,3.92l.35.45a2.32,2.32,0,0,1,0,2.9l-.36.46a.68.68,0,0,0,.11,1,.71.71,0,0,0,.42.14.72.72,0,0,0,.54-.25l.36-.46A3.68,3.68,0,0,0,28.49,20.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.54,27.69a.7.7,0,0,0-.48-.2.72.72,0,0,0-.48.2.67.67,0,0,0-.2.48.7.7,0,0,0,.2.49.72.72,0,0,0,.48.2.68.68,0,0,0,.68-.69A.67.67,0,0,0,27.54,27.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42,33.4a.67.67,0,0,0-.68.68,9.75,9.75,0,0,1-2.82,6.82.68.68,0,0,0,0,1,.65.65,0,0,0,.48.2.69.69,0,0,0,.48-.2,11.13,11.13,0,0,0,3.21-7.78A.67.67,0,0,0,42,33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.33,42.75a.69.69,0,0,0-.93-.26h0a.68.68,0,0,0-.26.93.66.66,0,0,0,.59.34.64.64,0,0,0,.33-.08h0A.69.69,0,0,0,37.33,42.75Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCafe);
export default __webpack_public_path__ + "static/media/cafe.dddbde26e7cf82e14d410c4cce2d1148.svg";
export { ForwardRef as ReactComponent };